<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-card
          width="420"
          class="mx-auto mt-5 rounded-lg"
          elevation="5"
          color="rgb(255, 255, 255, 0.9)"
        >
          <v-row>
            <v-col
              cols="12"
              style="background: "
              class="pt-10 pb-0 ma-0"
              align="center"
              justify="center"
            >
              <v-img
                alt="Vuetify Logo"
                class="shrink ma-0 pa-0"
                src="../../public/img/background/PentaWorld_Light.png"
                transition="scale-transition"
                width="250"
              />
            </v-col>
            <v-col style="background: " cols="12">
              <v-card-title class="pb-7 pt-0 pa-10 d-block text-center">
                <h2 class="title-tag">Synergy in Motion</h2>
              </v-card-title>
            </v-col>
          </v-row>
          <v-alert
            :value="alert"
            dense
            text
            type="warning"
            transition="scale-transition"
          >
            {{ pesan }}
          </v-alert>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Username"
                outlined
                class="pb-2"
                color="blue-grey"
                hide-details="auto"
                v-model="form.userid"
                prepend-inner-icon="mdi-account-circle"
              />
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                outlined
                color="blue-grey"
                hide-details="auto"
                prepend-inner-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-model="form.password"
              />
            </v-form>
          </v-card-text>
          <!-- width: 100% -->
          <div class="pb-10 px-4">
            <v-btn
              @click="handleLogin()"
              elevation="0"
              color="darken-4"
              style="
                width: 100%;
                background-color: rgb(114, 64, 31);
                color: white;
              "
              >Login</v-btn
            >
            <!-- <v-btn
              @click="handleAdmin()"
              class="white--text px-10 py-5 ml-2"
              elevation="0"
              color="blue-grey"
              >Admin</v-btn
            > -->
          </div>
        </v-card>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      alert: false,
      showPassword: false,
      form: {
        userid: "",
        password: "",
      },
      pesan: "",
      markerLatLng: [0, 0],
    };
  },
  methods: {
    handleLogin() {
      // this.$http.defaults.headers.common['apikey'] = `84641289-f577-473b-b8d0-58b17a2c4fc6`;
      this.axios
        .post(`${process.env.VUE_APP_API}/api/v2/login`, {
          userid: this.form.userid,
          password: this.form.password,
          lat: this.markerLatLng[0],
          lon: this.markerLatLng[1],
        })
        .then((response) => {
          const payload = response.data;
          console.log(payload);
          // console.log(payload.data)
          if (payload.success) {
            this.$store.commit("SET_LOGIN", "user");
            this.$store.commit("SET_USERINFO", payload.data);
            // console.log(this.$store.getters.loggedIn);
          } else {
            // this.alert = true;
            // console.log(payload.message);
          }
          this.$router.push("/user");
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            // const obj = JSON.parse(payload)
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            // const obj = JSON.parse(payload)
            this.pesan = payload;
            this.alert = true;
          }
          // console.log(payload.message);
        });
    },
    getIPinformation() {
      this.axios
        .get(`http://ip-api.com/json`)
        // .get(`http://json.geoiplookup.io/`)
        // .get(`https://www.cloudflare.com/cdn-cgi/trace`)
        .then((response) => {
          const payload = response.data;
          this.ipinfo = payload;
          this.markerLatLng[1] = payload.lon;
          this.markerLatLng[0] = payload.lat;
          //   console.log(this.ipinfo)
        });
    },
    handleAdmin() {
      this.$store.commit("SET_LOGIN", "admin");
      this.$router.replace("/admin");
    },
    // setLayout (layout) {
    //   this.$store.commit('SET_LAYOUT', layout)
    // }
  },
  created() {
    const success = (position) => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      // this.center = [latitude, longitude];
      this.markerLatLng = [latitude, longitude];
      // Do something with the position
    };

    const error = (err) => {
      console.log(error);
    };
    // this.getIPinformation()
    // This will open permission popup
    // navigator.geolocation.getCurrentPosition(success, error);
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Satisfy&display=swap");
.container {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-color: rgb(114, 64, 31);
  background-size: cover;
  overflow-y: hidden !important;
}
.title-tag {
  font-family: "Satisfy", cursive;
  font-size: 2.25rem;
  line-height: 2.5rem;
}
</style>
